import { Button, Stack } from '@mui/material';
import { useCandidateAuth } from 'features/auth';
import { useMyJobs } from 'features/myJobs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AsideSectionHeader, ContentCard } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';

import JobHistoryPreviewItem from './JobHistoryPreviewItem';

export default function JobHistoryPreview() {
    const { t } = useTranslation('candidateOffers', { keyPrefix: 'historyPreview' });
    const navigate = useNavigate();

    const { isAuthenticated } = useCandidateAuth();

    const { data: jobs } = useMyJobs({
        statuses: [ 'confirmed', 'applied' ],
        enabled: isAuthenticated,
        autoLoadUntilPast: false
    });

    if (!jobs?.length) {
        return null;
    }

    const handleViewAllJobs = () => {
        navigate(APP_ROUTES.myJobs);
    };

    return (
        <ContentCard>
            <AsideSectionHeader title={ t('title') }
                subtitle={ t('subtitle') } />

            <Stack spacing={ 2 }>
                { jobs.slice(0, 3).map(job => (
                    <JobHistoryPreviewItem key={ job.id }
                        job={ job } />  
                )) }

                <Button variant="outlined"
                    onClick={ handleViewAllJobs }
                >
                    { t('seeAll') }
                </Button>
            </Stack>
        </ContentCard>
    );
}
